// To display the rest of variants after clicking on +more btn 
document.addEventListener("click", (e)=>{
    if(e.target.closest(".custom-variants-limit-btn")) {
        const productCard = e.target.closest(".bls__product-option");
        if(!productCard)return;
        const variants = productCard.querySelectorAll(".bls__product-color-swatches.bls__option-swatch-js");
        const toggleBtn = productCard.querySelector(".custom-variants-limit-btn span");
        if(!toggleBtn) return;
        // more button
        toggleBtn.classList.toggle("negative-btn");
         // ACCESSIBILITY & button sign
    // Determine if we are now expanded or collapsed
    const isExpanded = toggleBtn.classList.contains("negative-btn");
    
    toggleBtn.setAttribute("aria-expanded", isExpanded);
    toggleBtn.setAttribute("aria-label", isExpanded ? "Show less variants" : "Show more variants");
        toggleBtn.innerHTML = isExpanded ? "-" : "+";

        // varaints container
        variants.forEach((variant)=> {
            const checkLimit = variant.dataset.variantLimit;
            if(checkLimit === "false") return;
            if(variant.classList.contains("not-reach-limit"))return;
                variant.classList.toggle("reach-limit");
            });
    }
});

